import { zhTW, zhHK, zhCN, vi, uk, tr, th, sv, sr, sk, sl, ru, ro, ptBR, pt, pl, nl, ms, lt, ko, kn, km, kk, ka, ja, it, id, hy, hu, hr, hi, he, frCA, fr, fi, es, de, da, cs, bn, bg, ar, enGB, enUS } from 'date-fns/locale';

/**
 * Mapping from i18next supported locales into date-fns locale objects
 */
var dateLocales = {
  en: enUS,
  'en-GB': enGB,
  ar: ar,
  bg: bg,
  bn: bn,
  cs: cs,
  da: da,
  de: de,
  es: es,
  fi: fi,
  fr: fr,
  'fr-CA': frCA,
  he: he,
  hi: hi,
  hr: hr,
  hu: hu,
  hy: hy,
  id: id,
  'id-ID': id,
  it: it,
  ja: ja,
  ka: ka,
  kk: kk,
  'km-KH': km,
  kn: kn,
  ko: ko,
  lt: lt,
  'ms-MY': ms,
  nl: nl,
  pl: pl,
  pt: pt,
  'pt-BR': ptBR,
  ro: ro,
  ru: ru,
  sl: sl,
  sk: sk,
  sr: sr,
  sv: sv,
  th: th,
  tr: tr,
  uk: uk,
  vi: vi,
  'vi-VN': vi,
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  'zh-TW': zhTW
};
export { dateLocales as default };